<template>
  <div id="layerSelect">
    <div v-for="(group) in groupedLayers" :key="group.id">
      <div class="list-header">
        {{ group[0].group }}
      </div>
      <ul class="menu-list">
        <li class="menu-list-item"
          v-for="(layer) in groupedLayer(group[0].group)" :key="layer.id">
          <div class="columns">
            <div class="column is-three-quarters">
              <input type="checkbox" :id="layer.id"
                v-if="!layer.items"
                v-model="layer.visible"
                v-on:click="$emit('selectedLayer', layer)">
              <i v-else class="far fa-caret-square-down" ></i>
              <span class="item-text">{{ layer.name }}</span>
            </div>
          </div>

          <ul v-if="layer.items">
            <li v-for="(subLayer) in layer.items" :key="subLayer.id">
              <div class="columns">
                <!-- Simply display name -->
                <div v-if="!subLayer.pager" class="column is-three-quarters">
                  {{ subLayer.name }}
                </div>
                <!-- Display name (smaller spacing) plus pager -->
                <div v-if="subLayer.pager" class="column is-one-half">
                  {{ subLayer.name }}
                </div>
                <!-- Pager: previous -->
                <div v-if="subLayer.pager" class="column routes-prev">
                  <i class="fa fa-angle-double-left"
                    v-on:click="onPagerPrevious(subLayer)">
                    <span>&nbsp;{{ subLayer.pager.current }} / {{subLayer.pager.max }}&nbsp;</span>
                  </i>
                </div>
                <!-- Pager: next -->
                <div v-if="subLayer.pager" class="column routes-next">
                  <i class="fa fa-angle-double-right"
                    v-on:click="onPagerNext(subLayer)">
                  </i>
                </div>
                <!-- Display checkbox -->
                <div class="column has-text-right">
                  <input type="checkbox"
                    v-model="subLayer.visible"
                    v-on:click="$emit('selectedLayer', subLayer)">
                </div>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LayerSelect',
  computed: {
    ...mapGetters({
      visibleLayers: 'mapControlsLayers',
    }),
    groupedLayers() {
      return this.groupLayers()
    }
  },
  methods: {
    groupLayers(){
      var result = {}
      for (var i = 0, len = this.visibleLayers.length; i < len; i++) {
        let group = this.visibleLayers[i].group
        if (!result[group]) {
          result[group] = []
        }
        result[group].push(this.visibleLayers[i])
      }
      return result
    },
    groupedLayer(group) {
      return this.groupLayers()[group]
    },
    onPagerPrevious(layer) {
      this.$store.commit('setLayerSelectPagerPrevious', layer.id)
    },
    onPagerNext(layer) {
      this.$store.commit('setLayerSelectPagerNext', layer.id)
    },
    prevRoute(layer) {
      for(let i = 0; i < this.visibleLayers.length; i++) {
        if(this.visibleLayers[i].id === layer.id) {
          let newValue = this.visibleLayers[i]
          newValue.routes_current -= 1
          if (newValue.routes_current <= 0) {
            newValue.routes_current = this.visibleLayers[i].routes_max
          }
          let src = this.map.getSource('trackers-routes')
          src.setData(this.trackerRoutes[newValue.routes_current - 1])
          break
        }
      }
    },
    nextRoute(layer) {
      for(let i = 0; i < this.visibleLayers.length; i++) {
        if(this.visibleLayers[i].id === layer.id) {
          let newValue = this.visibleLayers[i]
          newValue.routes_current += 1
          if (newValue.routes_current > this.visibleLayers[i].routes_max) {
            newValue.routes_current = 1
          }
          let src = this.map.getSource('trackers-routes')
          src.setData(this.trackerRoutes[newValue.routes_current - 1])
          break
        }
      }
    }
  }
}
</script>

<style scoped>
#layerSelect {
  width: 100%;
  align-self: flex-end;
  justify-self: left;
}

.layer-select-toggle {
  width: 20px;
}

.panel-block input[type=checkbox] {
  margin-right: 0;
}

.list-header {
  font-weight: bold;
  padding: 5px 0 5px 12px;
  /* padding-bottom: 5px; */
}
.item-text {
  margin-left: 10px;
}

.menu-list-item:first-child {
  border-top: 1px solid #dbdbdb;
}
.menu-list-item {
  border-bottom: 1px solid #dbdbdb;
  border-left: 1px solid #dbdbdb;
  border-right: 1px solid #dbdbdb;
  padding: 10px;
}
.menu-list li ul {
  margin: .35em;
}

.menu-list a {
  padding: .2em .5em;
  width: 80px;
}

div.routes {
  margin: auto;
  color:  gray;
  font-style: italic;
}
i.fa-angle-double-left {
  width: 70px;
}
i.routes span {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: normal;
}

.routes-prev {
  padding-right: 0;
}
.routes-next {
  padding-left: 0;
}

</style>
